<template>
  <nx-bform-group :label="name" v-bind="$attrs">
    <slot>
      <LoginPasswordFormField
        :name="name"
        :required="required"
        :value="$attrs.value"
        @input="$listeners.input"
      />
    </slot>
    <template #description>
      <LoginPasswordNewFormDescription />
    </template>
  </nx-bform-group>
</template>

<script>
import LoginPasswordFormField from "./LoginPasswordFormField";
import FormGroupMixin from "../form-group.mixin";
import LoginPasswordNewFormDescription from "./LoginPasswordNewFormDescription";

export default {
  mixins: [FormGroupMixin],
  components: {
    LoginPasswordFormField,
    LoginPasswordNewFormDescription,
  },
  computed: {
    name() {
      return this.label || this.$t("password");
    }
  }
};
</script>

<i18n src="@/locales/login.locale.json" />
